import { ArticleListCarousel } from 'components/ArticleListCarousel'
import Section from 'components/Section'
import { useMemoizedContentGetter } from 'utils/contentful'
import styles from './ArticleListCarouselSection.module.scss'

function ArticleListCarouselSection({ content }) {
  const { title, linkCta } = useMemoizedContentGetter(content, ['title', 'linkCta'])
  const relatedArticles = content?.fields?.relatedContentCollection?.items
  const config = content?.fields?.additionalConfiguration?.jsonContent
  return (
    <Section
      className={styles['container']}
      data-variant-background={config?.variantBackground}
      data-testid="article-list-carousel-section"
    >
      <ArticleListCarousel
        title={title?.textContent}
        relatedArticles={relatedArticles}
        linkCta={linkCta}
        config={config}
      />
    </Section>
  )
}

export { ArticleListCarouselSection }
export default ArticleListCarouselSection
